import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { handleCategory } from "./categorySlide";
import { getLabelCategories } from "../policy/policySlide";
import styles from "../policy/policy.module.scss";

export function CategoryForm() {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [parentId, setParentId] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const allCategories = useSelector((state) => state.policy?.categories ?? []);

  useEffect(() => {
    dispatch(getLabelCategories());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      loadCategoryDetails();
    }
  }, [id, dispatch]);

  const loadCategoryDetails = async () => {
    setLoading(true);
    try {
      const result = await dispatch(handleCategory({ action: 'get', id: parseInt(id) }));
      if (result.type === 'category/handleCategory/fulfilled') {
        const response = result.payload;
        if (response?.existed) {
          const category = response.existed;
          setName(category.name || "");
          setParentId(category.parent_id || "");
        }
      }
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const categoryData = {
      name,
      parent_id: parentId ? parseInt(parentId) : null,
      action: id ? 'update' : 'create',
    };
    if (id) {
      categoryData.id = parseInt(id);
    }
    try {
      await dispatch(handleCategory(categoryData));
      history.push('/category');
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await dispatch(handleCategory({ action: 'delete', id: parseInt(id) }));
      history.push('/category');
    } catch (error) {
      // Handle error
    } finally {
      setLoading(false);
      setShowDeleteConfirm(false);
    }
  };

  if (loading && !showDeleteConfirm) {
    return (
      <div className={styles.policyFormContainer}>
        <div className={styles.loadingState}>
          <div className={styles.loadingSpinner}></div>
          <p>Loading category details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.policyFormContainer}>
      <div className={styles.policyFormCard}>
        <div className={styles.formHeader}>
          <h2 className={styles.formTitle}>{id ? 'Update Category' : 'Create New Category'}</h2>
          <p className={styles.formSubtitle}>{id ? 'Modify the category details.' : 'Fill in the details for a new category.'}</p>
        </div>
        <form onSubmit={handleSubmit} className={styles.policyForm}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Category Name <span className={styles.required}>*</span></label>
            <input
              required
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={styles.formInput}
              placeholder="Enter category name"
            />
          </div>
          {/* <div className={styles.formGroup}>
            <label className={styles.formLabel}>Parent Category</label>
            <select
              value={parentId}
              onChange={(e) => setParentId(e.target.value)}
              className={styles.formSelect}
            >
              <option value="">No Parent</option>
              {Array.isArray(allCategories) && allCategories.map((cat) => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </select>
          </div> */}
          <div className={styles.formActions}>
            <div className={styles.leftActions}>
              {id && (
                <button type="button" onClick={() => setShowDeleteConfirm(true)} className={styles.deleteButton}>
                  Delete Category
                </button>
              )}
            </div>
            <div className={styles.rightActions}>
              <button type="button" onClick={() => history.push('/category')} className={styles.cancelButton}>
                Cancel
              </button>
              <button type="submit" className={styles.submitButton} disabled={loading}>
                {loading ? 'Saving...' : (id ? 'Update Category' : 'Create Category')}
              </button>
            </div>
          </div>
        </form>
        {showDeleteConfirm && (
          <div className={styles.deleteConfirmOverlay}>
            <div className={styles.deleteConfirmDialog}>
              <div className={styles.deleteConfirmHeader}>
                <h3>Confirm Delete</h3>
              </div>
              <div className={styles.deleteConfirmBody}>
                <p>Are you sure you want to delete this category?</p>
                <p className={styles.deleteWarning}>
                  This action cannot be undone.
                </p>
              </div>
              <div className={styles.deleteConfirmActions}>
                <button onClick={() => setShowDeleteConfirm(false)} className={styles.deleteConfirmCancelButton}>Cancel</button>
                <button onClick={handleDelete} className={styles.deleteConfirmDeleteButton} disabled={loading}>
                  {loading ? 'Deleting...' : 'Delete'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoryForm; 